import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  main: {
    width: '100%',
  },
  filterButton: {
    padding: theme.spacing(2),
    '& .MuiTypography-button': {
      display: 'flex',
    },
    float: 'right',
  },
  filterIcon: {
    display: 'flex',
    marginTop: '2px ',
  },
  filterButtonText: {
    color: theme.palette.primary.main,
    fontSize: '0.875rem',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  filterDrawer: {
    width: theme.spacing(50),
  },
  filterDrawerDiv: {
    padding: theme.spacing(3),
    width: theme.spacing(50),
  },
  closeIcon: {
    float: 'right',
    cursor: 'pointer',
    display: 'inline-block',
  },
  filterTypography: {
    display: 'inline-block',
  },
  circle: {
    borderRadius: '8px',
    textAlign: 'center',
    height: '16px',
    width: '16px',
    alignSelf: 'center',
    marginLeft: theme.spacing(1),
    backgroundColor: theme.palette.primary.dark,
    color: 'white',
    fontWeight: 500,
  },
}));

export default useStyles;
